import { useEffect } from 'react'
import { Box, makeStyles, Tooltip, Button } from '@material-ui/core';
import UtilService from '../../../../helper/service';
import { useDispatch, useSelector } from 'react-redux';
import {
  getAllAnalysisModerated,
  getExcludedParticipantsCallBack,
  getIdentifiers,
  getImmersionOverall,
  getSafetyOverall,
  getSessionRange,
  getStimulusAnalysis,
  removeGraphData,
  setLoading,
  updateFullLoadAnalysis,
  updateSessionRangeLive
} from '../../../../store/actions/creator/analysis';
import _ from 'underscore';
import AnalysisScoreIcon from '../../creator/analyzeScoreIcon';
import { apiClient } from '../../../../config/apiClient';
import constants from '../../../../config/constants';
import { useStylesTooltip } from "../../../../config/theme";
import { Skeleton } from '@material-ui/lab';

const useStyles = makeStyles((theme) => ({
  col: {
    display: 'flex',
    flexDirection: 'row',
    marginTop: 4
  },
  statuscontent: {
    fontFamily: 'Spartan-bold',
    color: '#697683',
    textAlign: 'right',
    paddingTop: theme.spacing(1),
    display: "flex",
    flexDirection: "column",
    justifyContent: "flex-end",
    alignItems: 'flex-end',
    '@media only screen and (max-width: 600px)': {
      paddingTop: 0,
    }
  },
  statusicon: {
    width: 24,
    height: 24
  },
  statustitle: {
    fontFamily: 'Spartan-bold',
    fontSize: (props: any) => props ? 20 : 25,
    color: '#1DB859',
    marginTop: 4
  },
  statustxt: {
    color: '#697683',
    fontSize: 20,
    fontFamily: 'Spartan-bold',
    paddingTop: theme.spacing(1),
    textTransform: 'capitalize'
  },
  icon: {
    width: 24,
    height: 24
  },
  tooltipDiv: {
    display: 'flex',
    alignItems: 'center'
  },
  stopBtn: {
    width: 40,
    height: 22,
    borderRadius: 3,
    background: '#D34A40',
    color: '#fff',
    textTransform: 'none',
    fontSize: 12,
    fontFamily: 'roboto-regular',
  },
  rec: {
    background: '#8192A2',
    color: '#FFFFFF',
    fontSize: 14,
    fontFamily: 'Spartan-regular',
    display: 'flex',
    alignItems: 'center',
    padding: '0 5px 0 4px!important',
    height: 22,
    borderRadius: 4,
    marginRight: 4,
    width: 85,
  },
  time: {
    fontFamily: 'Spartan-bold',
    marginTop: 3,
    fontSize: 16,
    marginLeft: 0,
  },
  recTime: {
    display: 'flex',
    justifyContent: 'center',
    width: 15,
  },
}));

interface IProps {
  pathname: string;
  isMobile: boolean;
  onStop: any;
  timer: any;
}

const ExperienceManagerModScore = (props: IProps) => {

  const { pathname, isMobile, onStop, timer } = props;
  const isOverhour = UtilService.getTimeInputLabel(timer, false) > 3600 * 15;

  const classes = useStyles(isMobile);
  const dispatch = useDispatch();

  const loginUserData = localStorage.getItem("user_data") ? JSON.parse(localStorage.getItem("user_data") || "{}") : ""
  const apolloClient = useSelector((state: any) => state.apolloClient);
  const { immersionIndex, safetyIndex, fullLoaded } = useSelector((state: any) => state.creatorExperienceManager);
  const {
    identifiers, tags, currentSession, immersion_overall, safety_overall, cliped,
    analyseStart, analyseEnd, all, excludedParticipants, updatedToLive, completed, overviewToKeymoment, settings
  } = useSelector((state: any) => state.analysis);
  const {
    session_type, session_trim_to, session_trim_from, scheduled_end_at,
    session_code, session_status, started_at, ended_at, session_length
  } = currentSession;
  const { liveDisabledIdentifers, mqttBackendCalcTime } = settings;
  const analysed_end = Math.floor(ended_at ? ended_at : scheduled_end_at);
  const isAvailableScore = session_status === 'LIVE' ? true : !isMobile;

  const duration = UtilService.getNowLocalTime() - Number(started_at) > 300 ? (
    (all.length > 3 && all.length <= constants.ANALYZE.LIVE_MOD_LIMIT_GRAPH_COUNTS) ? 10000 : 5000
  ) : 2000

  useEffect(() => {
    dispatch(setLoading(false));
    if (session_code) {
      dispatch(getIdentifiers(apolloClient.client, session_code, session_type === 'MODERATED'));
      const getStimulus = async () => {
        const res = await apiClient(true).get(`/stimulus/v2/stimulus/${loginUserData.customer_id}/${session_code}`);
        if (res.data && res.data[0] && Object.keys(res.data[0]).length !== 0) {
          dispatch(getStimulusAnalysis(res.data[0]))
        } else {
          dispatch(getStimulusAnalysis(null))
        }
      };
      getStimulus();
    }
  }, [session_code]);

  useEffect(() => {
    if (session_status !== 'LIVE' && !analyseStart && !analyseEnd && identifiers.length > 0) {
      dispatch(getSessionRange(session_trim_from ? Number(session_trim_from) : Number(started_at), session_trim_to ? Number(session_trim_to) : analysed_end))
    }
  }, [identifiers, completed])

  useEffect(() => {
    if (session_status === 'LIVE' && identifiers.length > 0 && (!analyseStart || !analyseEnd)) {
      dispatch(updateSessionRangeLive(Number(started_at), UtilService.getNowLocalTime() <= Number(started_at) ? UtilService.getNowLocalTime() + 10 : UtilService.getNowLocalTime()))
    }
  }, [identifiers, all, updatedToLive, started_at]);

  useEffect(() => {
    if (session_status === 'LIVE' && session_type === 'MODERATED' && pathname.includes('/experience-manager/analyze')) {
      dispatch(updateFullLoadAnalysis(false));
    }
  }, []);

  useEffect(() => {
    if (identifiers.length > 0 && analyseStart && analyseEnd && session_code) {
      dispatch(getExcludedParticipantsCallBack(apolloClient.client, session_code, (res: any) => {
        if (res) {
          const _excludedParticipants = res.map((item: any) => item.identifier);
          const allExisted = all.findIndex((item: any) => item.activeParticipant === 'All');

          const request = {
            identifiers: _.difference(identifiers, _excludedParticipants),
            from_epoch: analyseStart,
            to_epoch: analyseEnd,
            session_started_at: session_trim_from ? Number(started_at) : analyseStart,
            session_completed_at: session_trim_to ? analysed_end : analyseEnd,
            tenant_id: Number(loginUserData.customer_id),
            session_code,
          };

          const type = (session_type === 'MODERATED') ? 'sync' : 'async';
          const status = (session_status === 'LIVE') ? 'aggregate' : 'analysis';

          if (allExisted === -1) {
            setTimeout(() => {
              onCallingAllData(['All'], _excludedParticipants, 'All', analyseStart, analyseEnd, true, false);
            }, 2000);
          } else {

            if (session_status !== 'LIVE' && !overviewToKeymoment) {
              onCallingAllData(['All'], _excludedParticipants, 'All', analyseStart, analyseEnd, true, false); // excludeparticiapnts are reculated.
              tags
                .filter((item: any) => all.map((item: any) => item.activeParticipant).includes(item.tagName))
                .map((item: any) => {
                  dispatch(removeGraphData(item['tagName']));
                  onCallingAllData(_.difference(item['identifiers'], _excludedParticipants), _excludedParticipants, item['tagName'], analyseStart, analyseEnd, false, true)
                })
            }

            if (!safety_overall) {
              dispatch(getSafetyOverall(request, loginUserData.customer_id, session_code, type, status))
            }
            if (!immersion_overall) {
              dispatch(getImmersionOverall(request, loginUserData.customer_id, session_code, type, status))
            }
          }
        }
      }
      ));
    }
  }, [analyseStart && identifiers.length, mqttBackendCalcTime]);

  useEffect(() => {
    const myInterval = setInterval(async () => {
      if (session_status === 'LIVE' && !pathname.includes('/overview')) {

        dispatch(getIdentifiers(apolloClient.client, session_code, session_type === 'MODERATED'));

        if (identifiers.length > 0 && analyseStart && analyseEnd) {
          dispatch(updateSessionRangeLive(Number(started_at), UtilService.getNowLocalTime() - 10));
          await onCallingAllData(['All'], excludedParticipants, 'All', analyseStart, UtilService.getNowLocalTime() - 5, false, false);

          const users2D = get2DArray(identifiers.filter((item: string) => all.map((x: any) => x.activeParticipant).includes(item)), 2);
          for (const users of users2D) {
            await Promise.all(users.map(async (item: string) => await onCallingAllData([item], excludedParticipants, item, analyseStart, UtilService.getNowLocalTime() - 5, false, false)))
          }

          const tags2D = get2DArray(tags.filter((item: any) => all.map((x: any) => x.activeParticipant).includes(item['tagName'])), 2);
          for (const tags of tags2D) {
            await Promise.all(tags.map(async (item: any) => await onCallingAllData(item['identifiers'], excludedParticipants, item['tagName'], analyseStart, UtilService.getNowLocalTime() - 5, false, true)))
          }
        }
      }
    }, duration);
    return () => {
      clearInterval(myInterval);
    };
  }, [currentSession, identifiers, all, analyseStart, analyseEnd, updatedToLive, isMobile]);

  const onCallingAllData = async (_identifiers: string[], _excludedParticipants: string[], name: any, from_epoch: number, to_epoch: number, showLoading: boolean, isTag: boolean) => {

    const request = {
      identifiers: (name === 'All') ? _.difference(identifiers, _excludedParticipants) : [..._identifiers],
      from_epoch: from_epoch ? from_epoch : Number(started_at),
      to_epoch,
      session_started_at: (analyseStart && !session_trim_from) ? analyseStart : Number(started_at),
      session_completed_at: (analyseEnd && !session_trim_to) ? (session_status === 'LIVE' ? analysed_end : analyseEnd) : analysed_end,
      tenant_id: Number(loginUserData.customer_id),
      session_code,
    };

    dispatch(await getAllAnalysisModerated(request, loginUserData.customer_id, session_code, name, session_status, name === 'All', showLoading, isTag, liveDisabledIdentifers))
  }

  const getScorePane = (isMobile: boolean) => {
    if (cliped) {
      const clipLength = Number(cliped.end_clip - cliped.start_clip);
      return <ScorePane immersion={cliped['score']['immersion']} safety={cliped['score']['safety']}
        session_status={session_status} fullLoaded={fullLoaded} length={clipLength} isMobile={isMobile} />
    } else {
      return <ScorePane immersion={immersion_overall} safety={safety_overall}
        session_status={session_status} fullLoaded={fullLoaded} length={Number(session_length)} isMobile={isMobile} />
    }
  };

  return (
    <>
      {isAvailableScore && (
        <Box className={classes.statuscontent}>
          {pathname.includes('/overview') ? (
            (session_status === 'LIVE' || cliped)
              ? getScorePane(isMobile)
              : <ScorePane immersion={immersionIndex} safety={safetyIndex}
                session_status={session_status} fullLoaded={fullLoaded} length={Number(session_length)} />
          ) : getScorePane(isMobile)}
          {!isMobile && <Box className={classes.statustxt}>
            {UtilService.formattingString(session_status)}
          </Box>}
          {isMobile && timer !== '00:00:00' && <div className={classes.col}>
            <div className={classes.rec} style={{ width: !isOverhour ? 62 : 85 }}>
              <div className={classes.recTime}>
                <img src={'/assets/icons/liveanalysis/rec-icon.svg'} alt={'img'} />&nbsp;
              </div>
              <div className={classes.time}>
                <span>{!isOverhour ? timer?.slice(3) : timer}</span>
              </div>
            </div>
            <Button className={classes.stopBtn} onClick={onStop}>
              <span style={{ marginLeft: 5, marginRight: 5 }}>Stop</span>
            </Button>
          </div>}

        </Box>
      )}
    </>
  )
}

export default ExperienceManagerModScore;

function ScorePane(props: any) {

  const { immersion, safety, session_status, fullLoaded, length, isMobile } = props;
  const classes = useStyles(isMobile);
  const tooltipClasses = useStylesTooltip();
  const iconSize = isMobile ? 2 : 1;

  return (
    <Box display="flex" flexDirection="row" justifyContent="flex-end">
      {immersion ? (
        <Box display="flex" flexDirection="row" justifyContent="flex-start" alignItems="center">
          <Tooltip classes={tooltipClasses} title="Immersion Index: Scale of 1 - 100" placement="bottom" arrow>
            <div className={classes.tooltipDiv}>
              <AnalysisScoreIcon color={immersion.immersion_index > 0 ? immersion.color_indicator : 'gray'} type={'immersion'} size={iconSize} />
              <Box pl={1} className={classes.statustitle} style={{ color: UtilService.refactorGraphColor(immersion.color_indicator) }}>
                {immersion.immersion_index > 0 ? immersion.immersion_index : '--'}
              </Box>
            </div>
          </Tooltip>
        </Box>
      ) : (
        <Box display="flex" flexDirection="row" justifyContent="flex-start" alignItems="center">
          {(session_status === 'UPCOMING' || fullLoaded) ? <Tooltip classes={tooltipClasses} title="Immersion Index: Scale of 1 - 100" placement="bottom" arrow>
            <div className={classes.tooltipDiv}>
              <AnalysisScoreIcon color={'green'} type={'immersion'} size={iconSize} />
              <Box pl={1} className={classes.statustitle} style={{ color: '#1DB859', marginTop: 0 }}>--</Box>
            </div>
          </Tooltip>
            : <Skeleton width={50} height={30} />}
        </Box>
      )}
      {(safety && safety.safety_index > 1 && UtilService.isShowSafety('MODERATED', length)) && (
        <Box pl={isMobile ? 1 : 2} display="flex" flexDirection="row" justifyContent="flex-start" alignItems="center">
          <Tooltip classes={tooltipClasses} title="Psychological Safety Index: Scale of 1 - 100" placement="bottom" arrow>
            <div className={classes.tooltipDiv}>
              <AnalysisScoreIcon color={safety.color_indicator} type={'safety'} size={iconSize} />
              <Box pl={1} className={classes.statustitle} style={{ color: UtilService.refactorGraphColor(safety.color_indicator) }}>
                {safety.safety_index}
              </Box>
            </div>
          </Tooltip>
        </Box>
      )}
    </Box>
  )
}

const get2DArray = (items: any[], numItems: number): any[][] => {
  const data = []
  const len = Math.ceil(items.length / numItems);
  for (let i = 0; i < len; i++) {
    let end = (i + 1) * numItems;
    if (end > items.length) {
      end = items.length;
    }
    data.push(items.slice(i * numItems, end))
  }
  return data;
}